
import {Vue, Component, Prop} from 'vue-property-decorator';
import {CreateElement, VNode} from 'vue';
import {formatCardMask} from '@/utils/strings.ts';

export default Vue.component('credit-card', {
  functional: true,
  props: {
    cardNumber: {
      type: Object,
      default: () => {},
    },
    mobView: {
      type: Boolean,
      default: false,
    },
  },
  render(createElement: CreateElement, context): VNode {
    const cardMask = context.props.cardNumber && context.props.cardNumber.mask ? context.props.cardNumber.mask : '';
    const cardType = cardMask[0] === '5' ? 'master' : cardMask[0] === '4' ? 'visa' : 'other';
    const cardImg: VNode = createElement('img', {
      class: 'credit-card-item-img',
      attrs: {
        src: require(`@/assets/${cardType}-card.png`),
        alt: cardType,
      },
    });
    const cardBlock: VNode = createElement('div', {
          class: {
            'credit-card': true,
            'credit-card__mob': context.props.mobView,
          },
        }, [
          createElement('div', {
                class: ['credit-card-item', 'p6'],
              },
              [cardImg, createElement('span', {
                    class: 'p1',
                  },
                  formatCardMask(cardMask))],
          ),
        ],
    );
    return cardBlock;
  },
});
